const askkama = async(pid,urlKey, entity) => {
    const response = await fetch("/api/askkama", {
        method: "POST",
        body: JSON.stringify({
            pid,
            urlKey,
            entity
        }),
        headers: {
            "Content-Type": "application/json",
        },
    });

    const data = await response.json();

    if (!response.ok) {
        return data;
    }

    return data;
}

export default askkama